import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

export const Flex = styled.div`
  display: flex;
  flex-direction: row;
  ${props => (props.s ? css(props.s(props)) : '')}
  ${props =>
    props.onClick && {
      [':hover']: {
        cursor: 'pointer',
      },
    }}
`

Flex.propTypes = {
  s: PropTypes.func,
}
